import React, { FC } from 'react';
import { Image as KonvaImage, Rect } from 'react-konva';

import { AdBackground } from '../../model/types';
import { useImageElement } from '../../utils/image';
import { coverCrop } from './shapeGeometry';

interface BackgroundNodeProps {
  background: AdBackground;
  width: number;
  height: number;
}

/** Punkty startu i końca gradientu wyliczone z kąta podanego w stopniach. */
const gradientPoints = (angle: number, width: number, height: number) => {
  const radians = (angle * Math.PI) / 180;
  const halfWidth = width / 2;
  const halfHeight = height / 2;
  const dx = Math.cos(radians) * halfWidth;
  const dy = Math.sin(radians) * halfHeight;
  return {
    start: { x: halfWidth - dx, y: halfHeight - dy },
    end: { x: halfWidth + dx, y: halfHeight + dy },
  };
};

export const BackgroundNode: FC<BackgroundNodeProps> = ({ background, width, height }) => {
  const image = useImageElement(background.kind === 'image' ? background.imageSrc : '');
  const { start, end } = gradientPoints(background.gradientAngle, width, height);

  return (
    <>
      <Rect
        width={width}
        height={height}
        listening={false}
        fill={background.kind === 'gradient' ? undefined : background.color}
        fillLinearGradientStartPoint={background.kind === 'gradient' ? start : undefined}
        fillLinearGradientEndPoint={background.kind === 'gradient' ? end : undefined}
        fillLinearGradientColorStops={background.kind === 'gradient'
          ? [0, background.gradientFrom, 1, background.gradientTo]
          : undefined}
      />
      {background.kind === 'image' && image && (
        <KonvaImage
          image={image}
          width={width}
          height={height}
          crop={coverCrop(image, width, height)}
          listening={false}
        />
      )}
      {/* Bez wczytanego zdjęcia przyciemnienie nie ma czego przykrywać, a
          zaciemniałoby czystą planszę zaraz po wybraniu trybu „zdjęcie". */}
      {background.kind === 'image' && Boolean(image) && background.overlayOpacity > 0 && (
        <Rect
          width={width}
          height={height}
          fill={background.overlayColor}
          opacity={background.overlayOpacity}
          listening={false}
        />
      )}
    </>
  );
};
